/**
 * @file 应用入口
 * @author fengfaxia(fengfaxia@baidu.com))
 */
// import 'babel-polyfill';

import React from 'react';
import {render} from 'react-dom';
import {Provider} from 'react-redux';
import Routes from './router/router';
import store from './store/store';
import './css/common.less';
render(
  <Provider store={store}>
      <Routes />
  </Provider>,
  document.getElementById('root')
);

function loadBdFeedback() {
    const feedbackJs = document.createElement('script');
    feedbackJs.setAttribute('type', 'text/javascript');
    feedbackJs.setAttribute('src', './static/ufo.js');
    document.body.appendChild(feedbackJs);
}
loadBdFeedback();
